var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSalesHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;fill-rule:evenodd;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M22,24H17a1,1,0,0,1-1-1V1a1,1,0,0,1,1-1h5a1,1,0,0,1,1,1V23A1,1,0,0,1,22,24ZM21,2H18V22h3ZM14,24H9a1,1,0,0,1-1-1V13a1,1,0,0,1,1-1h5a1,1,0,0,1,1,1V23A1,1,0,0,1,14,24ZM13,14H10v8h3ZM6,24H1a1,1,0,0,1-1-1V8A1,1,0,0,1,1,7H6A1,1,0,0,1,7,8V23A1,1,0,0,1,6,24ZM5,9H2V22H5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesHistory);
export default __webpack_public_path__ + "static/media/sales-history.b7859e11ccd2502715bd003bbf09aeaa.svg";
export { ForwardRef as ReactComponent };